export enum AddOnProductType {
    ABC = 1,
    CarouselCollection,
}

export enum NotificationType {
    Collection = 1,
    Injection,
    Delivery,
    MissingBag = 7,
    CustomerSmsReply = 6,
    FlightCancelled = 11,
    FlightDelayed = 12,
    OneHourCollection = 15,
}

export enum NotificationStatus {
    Active = 1,
    ManuallyResolved,
    SystemResolved,
}
